import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_FACILITIES_REQUEST: '',
  GET_FACILITIES_SUCCESS: '',
  GET_FACILITIES_FAILURE: '',

  GET_CLAIMS_FACILITIES_REQUEST: '',
  GET_CLAIMS_FACILITIES_SUCCESS: '',
  GET_CLAIMS_FACILITIES_FAILURE: ''
};

types = setStoreTypeValues(types, 'authFacilities');

export default types;
